import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class BankAccountEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/bank-accounts", params);
  }

  public integrities(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/bank-accounts/integrity-checks", params);
  }

  public runIntegrity(account: number): Promise<AxiosResponse> {
    return $api.post(`a/bank-accounts/${account}/integrity-checks`);
  }
}

export default BankAccountEndpoint;
